import { WeaTools } from "ecCom";
export default {
  logView: params => WeaTools.callApi("/api/common/log/view", "POST", params),
  viewDetail: params =>
    WeaTools.callApi("/api/common/log/viewdetail", "GET", params),
  trans: params =>
    WeaTools.callApi("/api/common/log/audit/trans", "GET", params),
  getdata: params => WeaTools.callApi("/api/common/log/getdata", "GET", params),
  tableExport: params => {
    return WeaTools.callApi("/api/ec/dev/table/export", "POST", params);
  }
};



// WEBPACK FOOTER //
// ./comMobx/wea-log-view/apis/Api.js